/* tslint:disable */
/* eslint-disable */
/**
 * Eatgrim Shipping API
 * Eatgrim Shipping API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@soundsgood.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DateSlotFromJSON, DateSlotToJSON, } from './';
export function DoorstepDeliveryLocationFromJSON(json) {
    return DoorstepDeliveryLocationFromJSONTyped(json, false);
}
export function DoorstepDeliveryLocationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'price': json['price'],
        'slots': (json['slots'].map(DateSlotFromJSON)),
        'zipCode': json['zipCode'],
    };
}
export function DoorstepDeliveryLocationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'price': value.price,
        'slots': (value.slots.map(DateSlotToJSON)),
        'zipCode': value.zipCode,
    };
}
